var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84625 11.048L9.4927 11.4016L10.1998 12.1087L10.5534 11.7551L9.84625 11.048ZM12.5998 9.00156L12.9534 9.35512L13.3069 9.00156L12.9534 8.64801L12.5998 9.00156ZM10.5534 6.24801L10.1998 5.89446L9.4927 6.60156L9.84625 6.95512L10.5534 6.24801ZM10.5534 11.7551L12.9534 9.35512L12.2463 8.64801L9.84625 11.048L10.5534 11.7551ZM12.9534 8.64801L10.5534 6.24801L9.84625 6.95512L12.2463 9.35512L12.9534 8.64801ZM12.5998 8.50156H4.7998V9.50156H12.5998V8.50156Z",
    fill: "#3A4F68"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightSmall);
export default __webpack_public_path__ + "static/media/arrow-right-small.abe27140f3eec64b07726d48e01f618d.svg";
export { ForwardRef as ReactComponent };